import {Injectable} from '@angular/core';
import * as storeActions from '@catcore/actions/features';
import {FeatureType, FeatureTypeCreateInfo} from '@catcore/services/feature-type/feature-type';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {Store} from '@ngrx/store';
import {Restangular} from 'ngx-restangular';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class EvidVidsService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('evid-vids', service);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/evid-vids/services/evid-vids.service.ts